import {inject} from '@angular/core';
import {MediaObserver} from '@ngbracket/ngx-layout';

export function isMobile(): boolean {
    const mediaObserver = inject(MediaObserver);
    return mediaObserver.isActive('mobile');
}

export function isWebView(): boolean {
    const rules = [
        'WebView',
        '(iPhone|iPod|iPad)(?!.*Safari)',
        'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
        'Linux; U; Android'
    ];
    const webviewRegExp = new RegExp(`(${rules.join('|')})`, 'ig');

    return !!navigator.userAgent.match(webviewRegExp);
}

export function isDeviceInPortraitMode(): boolean {
    const orientation = screen.orientation?.type || window.orientation;
    return (
        (typeof orientation === 'string' && orientation.includes('portrait')) ||
        (typeof orientation === 'number' && (orientation === 0 || orientation === 180))
    );
}
